import React from 'react'
import { Helmet } from 'react-helmet';

const EventsCalendar = () => {
    return (
        <div>
            <Helmet>
                <title>Events Calendar</title>
            </Helmet>
            <div className='main-container'>
            <div className="page-bg"></div>
        <div className="page-bg page-bg2"></div>
        <div className="page-bg page-bg3"></div>
        
                <div className="section">
                    <div className="page-heading">
                        <h1>Events Calendar</h1>
                    </div>

                    <iframe src="https://calendar.google.com/calendar/embed?height=600&wkst=1&bgcolor=%23ffffff&ctz=Asia%2FKolkata&showTitle=0&showPrint=0&showTz=0&src=dmlrcmFudC5rQGlpdGduLmFjLmlu&src=Y18wMmE0YmUzYjU4YTk2NDBhZWQxYjliOGIzYTUzYTVlMWRhNDY2ODc0M2Q5YjQ0MjU5ZDA5ZmNhMjhkZTAwZDRmQGdyb3VwLmNhbGVuZGFyLmdvb2dsZS5jb20&src=YWRkcmVzc2Jvb2sjY29udGFjdHNAZ3JvdXAudi5jYWxlbmRhci5nb29nbGUuY29t&color=%23039BE5&color=%239E69AF&color=%2333B679" width="100%" height="600" style={{
                        border: '0',
                        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
                        borderRadius: '5px'
                    }}
                    allowFullScreen=""
                    aria-hidden="false"
                    tabIndex={0}
                    referrerPolicy="no-referrer-when-downgrade"
                    title='Google Calendar'></iframe>



                    

                    

                    {/* <iframe src="https://calendar.google.com/calendar/embed?height=600&wkst=1&bgcolor=%23039BE5&ctz=UTC&showTitle=1&showNav=1&showTz=1&showPrint=0&showTabs=1&title=Sports%20Events%20at%20IIT%20Gandhinagar&src=Y2hhdWRoYXJ5bWFjMjYwNEBnbWFpbC5jb20&color=%23039BE5" width="100%"
                    height="600"
                    style={{
                        border: '0',
                        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
                        borderRadius: '5px'
                    }}
                    allowFullScreen=""
                    aria-hidden="false"
                    tabIndex={0}
                    referrerPolicy="no-referrer-when-downgrade"
                    title='Google Calendar'></iframe> */}
                    
                    


        

                </div>
            </div>

        </div>
    )
}

export default EventsCalendar